import { useEffect } from 'react';

import type { History, Location } from 'history';
import type { FC } from 'react';
import type { match } from 'react-router';

import Redirect from '@app/components/redirect';

import { clientLogger } from '@flow/logging';

type Props = {
  history?: History;
  location?: Location;
  match?: match;
  redirect?: boolean;
  to?: string;
};

export const NotFound: FC<Props> = ({ history, location, match, redirect = false, to }) => {
  useEffect(() => {
    clientLogger.warn('Route not found', {
      history,
      location,
      match,
      redirect,
      to,
    });

    if (!redirect) {
      window.location.reload(true);
    }
  }, [
    history,
    location,
    match,
    redirect,
    to,
  ]);

  if (!redirect || !to) {
    return null;
  }

  return <Redirect to={to} />;
};
